var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crossword-game',{staticClass:"crossword",attrs:{"words":_vm.words,"show-play-again":false},on:{"gameFinished":_vm.gameFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }